import { render, staticRenderFns } from "./GStudentImportErrorModal.vue?vue&type=template&id=df106372&scoped=true&"
import script from "./GStudentImportErrorModal.vue?vue&type=script&lang=ts&"
export * from "./GStudentImportErrorModal.vue?vue&type=script&lang=ts&"
import style0 from "./GStudentImportErrorModal.vue?vue&type=style&index=0&id=df106372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df106372",
  null
  
)

export default component.exports